import React from "react";
import { Link } from "react-router-dom";
import { BrandLogoImg } from "@/components/BrandLogoImg";

export default function Logo({ compact = false, center = false, withIcon = false }) {
  const text = (
    <span className="inline-flex flex-col items-center leading-none">
      <span className="font-heading font-black text-[#1e3a8a] text-2xl md:text-3xl tracking-tight">
        AMC
      </span>
      <span className="font-heading font-black text-[#1e3a8a] text-xl md:text-2xl tracking-tight -mt-1">
        ESCOLAS
      </span>
      <span className="h-[2px] w-full bg-red-500 mt-1" />
      {!compact && (
        <span className="text-[8px] text-slate-500 font-bold mt-1 tracking-[0.2em] uppercase">
          Manutenção de escolas
        </span>
      )}
    </span>
  );
  return (
    <Link
      to="/"
      className={`inline-flex items-center gap-2 leading-none ${center ? "mx-auto" : ""}`}
      data-testid="app-logo"
    >
      {withIcon && <BrandLogoImg className="w-11 h-11 md:w-12 md:h-12 object-contain rounded-full" data-testid="app-logo-icon" />}
      {text}
    </Link>
  );
}
